class LocalDataHandler {
  constructor() {
    this.KEY_LOCAL_KEYS = 'local_keys';
    this.KEY_MENU_ITEM = 'menu_item';
  }

  /**
   * Function to get the instance of the handler
   */
  static getInstance() {
    if (this.instance == null) {
      this.instance = new LocalDataHandler()
    }
    return this.instance
  }

  clearLocalData() {
    let keys = localStorage.getItem(this.KEY_LOCAL_KEYS)
    if (keys == null) {
      return
    }
    localStorage.removeItem(this.KEY_LOCAL_KEYS)
  }

  /** general functions to save data into local storage **/
  saveLocalKey(keyName) {
    let keys = localStorage.getItem(this.KEY_LOCAL_KEYS)
    if (keys == null) {
      localStorage.setItem(this.KEY_LOCAL_KEYS, JSON.stringify([keyName]))
      return
    }
    let keyArray = JSON.parse(keys)
    if (keyArray.indexOf(keyName) === -1) {
      keyArray.push(keyName)
      localStorage.setItem(this.KEY_LOCAL_KEYS, JSON.stringify(keyArray))
    }
  }

  saveLocalData(keyName, data) {
    this.saveLocalKey(keyName)
    if (typeof data === 'string') {
      localStorage.setItem(keyName, data)
      return
    }
    localStorage.setItem(keyName, JSON.stringify(data))
  }

  getLocalData(keyName) {
    let data = localStorage.getItem(keyName)
    if (data == null) return data
    try {
      // return the parsed json object
      return JSON.parse(data)
    } catch (e) {
      // error means this is not a json data, which is a saved string
      return data
    }
  }

  removeLocalKey(keyName) {
    let keys = localStorage.getItem(this.KEY_LOCAL_KEYS)
    if (keys == null) {
      return
    }
    let keyArray = JSON.parse(keys)
    let index = keyArray.indexOf(keyName)
    if (index !== -1) {
      keyArray.splice(index, 1)
      localStorage.setItem(this.KEY_LOCAL_KEYS, JSON.stringify(keyArray))
    }
  }

  removeLocalData(keyName) {
    this.removeLocalKey(keyName)
    localStorage.removeItem(keyName)
  }

  /** key-specific functions to save data into local storage **/
  saveMenuItem(item) {
    this.saveLocalData(this.KEY_MENU_ITEM, item)
  }

  getMenuItem() {
    return this.getLocalData(this.KEY_MENU_ITEM)
  }
}

export default LocalDataHandler.getInstance()
